module.exports = ['$scope', 'settings', '$cookies', '$sce', '$uibModal', 'moment', function ($scope, settings, $cookies, $sce, $uibModal, moment) {
  'use strict';
  function getFormattedDate(date) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return day + '/' + month + '/' + year;
  }

  /*
  vskoApi.getAllResources('/content', {
      typeIn: 'NEWSITEM',
      requiredBy: settings.theme,
      orderBy: 'issued',
      descending: true,
      limit: 1,
      issuedGreater: '2016-01-01'
    },
    null,
    settings.apisAndUrls.api).then(function (data) {
    data[0].issued = getFormattedDate(new Date(data[0].issued));
    $scope.news = data[0];

  });
  */

  function isValidDate({ startDate, endDate }) {
    let valid = true;
    const today = moment();

    if(startDate && startDate !== '') {
      valid = moment(startDate).isSameOrBefore(today);
    }
    if(valid && endDate && endDate !== '') {
      valid = moment(endDate).isSameOrAfter(today);
    }

    return valid;
  }

  function createCookie(item) {
    const expires = moment().add(item.ttl || 1, item.ttlUnit || 'days').toDate();
    $cookies.put(`popup-${item.key}`, true, { expires });
  }

  if(settings.popup && settings.popup.length > 0) {

    settings.popup.forEach(popup => {
      const html = $sce.trustAsHtml(popup.body);
      const cookie = $cookies.get(`popup-${popup.key}`);

      if (!cookie && isValidDate(popup)) {
        const modal = $uibModal.open({
          size: 'sm',
          template: `
          <div class="popup">
            <div class="modal-header">
              <div class="title-content">
                <div class="title"> ${popup.title}</div>
              </div>  
              <div class="close">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true">×</span></button>
              </div>
            </div>
            <div class="modal-body">
              <div class="resource custom-html">
                <div>${html}</div>
              </div>
            </div>
          </div>`,
          backdrop: true,
          windowClass: 'popup-main',
          controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            'ngInject';

            $scope.cancel = () => $uibModalInstance.dismiss({ $value: 'cancel' });
            $scope.accept = () => $uibModalInstance.close({ $value: 'accept' });
          }]
        });

        modal.result.then(() => createCookie(popup), () => createCookie(popup));
        return;
      }
    });
    /*const { popup } = settings;
    const [firstPopup] = popup;
    const html = $sce.trustAsHtml(firstPopup.body);
    const cookie = $cookies.get(`popup-${firstPopup.key}`);

    if (!cookie && isValidDate(firstPopup)) {
      const modal = $uibModal.open({
        size: 'sm',
        template: `
          <div class="popup">
            <div class="modal-header">
              <div class="title-content">
                <div class="title"> ${firstPopup.title}</div>
              </div>
              <div class="close">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true">×</span></button>
              </div>
            </div>
            <div class="modal-body">
              <div class="resource custom-html">
                <div>${html}</div>
              </div>
            </div>
          </div>`,
        backdrop: true,
        windowClass: 'popup-main',
        controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
          'ngInject';

          $scope.cancel = () => $uibModalInstance.dismiss({ $value: 'cancel' });
          $scope.accept = () => $uibModalInstance.close({ $value: 'accept' });
        }]
      });

      modal.result.then(() => createCookie(firstPopup), () => createCookie(firstPopup));
    }*/
  }
}];



// WEBPACK FOOTER //
// ./web/js/screen/home/homeController.js